// Adresní řádek pro okna typu Průzkumník: Zpět / Vpřed / O úroveň výš + drobečková cesta. Sedí pod ribbonem.
import { h, clear } from '../dom';
import { t } from '../i18n';
import { icon } from '../icons';

export interface AddressNav {
  canBack: boolean;
  canForward: boolean;
  canUp: boolean;
  onBack: () => void;
  onForward: () => void;
  onUp: () => void;
}

export class IwAddressBar extends HTMLElement {
  private treeBtn = h('button', { type: 'button', class: 'btn ghost sm tree-toggle', title: t('soubory.tree_toggle'), hidden: true }, icon('sidebar'));
  private back = h('button', { type: 'button', class: 'btn ghost sm', title: t('soubory.back') }, icon('arrow-left'));
  private fwd = h('button', { type: 'button', class: 'btn ghost sm', title: t('soubory.forward') }, icon('arrow-right'));
  private up = h('button', { type: 'button', class: 'btn ghost sm', title: t('soubory.up') }, icon('arrow-up'));
  private crumbsEl = h('div', { class: 'crumbs', role: 'navigation' });
  private nav: AddressNav | null = null;

  connectedCallback(): void {
    if (this.hasChildNodes()) return;
    this.append(this.treeBtn, this.back, this.fwd, this.up, this.crumbsEl);
    this.back.addEventListener('click', () => this.nav?.onBack());
    this.fwd.addEventListener('click', () => this.nav?.onForward());
    this.up.addEventListener('click', () => this.nav?.onUp());
  }

  setNav(nav: AddressNav): void {
    this.nav = nav;
    this.back.disabled = !nav.canBack;
    this.fwd.disabled = !nav.canForward;
    this.up.disabled = !nav.canUp;
  }

  /** Tlačítko Strom (schovat/ukázat strom složek); bez volání zůstává skryté. */
  onTreeToggle(cb: () => void): void {
    this.treeBtn.hidden = false;
    this.treeBtn.addEventListener('click', cb);
  }

  setTreeShown(shown: boolean): void {
    this.treeBtn.classList.toggle('active', shown);
    this.treeBtn.setAttribute('aria-pressed', shown ? 'true' : 'false');
  }

  /** Cesta od kořene; klik na část naviguje. */
  setPath(path: { id: string; name: string }[], onNavigate: (id: string) => void): void {
    clear(this.crumbsEl);
    path.forEach((p, i) => {
      const b = h('button', { type: 'button', class: 'crumb' }, p.name);
      b.addEventListener('click', () => onNavigate(p.id));
      this.crumbsEl.appendChild(b);
      if (i < path.length - 1) this.crumbsEl.appendChild(icon('chevron', 'icon crumb-sep'));
    });
  }

  /** Prvky napravo od cesty (např. Nahrát v okně Vybrat soubor). */
  extra(): HTMLElement {
    let ex = this.querySelector<HTMLElement>('.address-extra');
    if (!ex) {
      ex = h('div', { class: 'address-extra' });
      this.appendChild(ex);
    }
    return ex;
  }
}

customElements.define('iw-addressbar', IwAddressBar);
